import { render, staticRenderFns } from "./AddPracticeModal.vue?vue&type=template&id=e2f38b32"
import script from "./AddPracticeModal.vue?vue&type=script&lang=ts"
export * from "./AddPracticeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports